import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "asset-group-form" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-4"
}
const _hoisted_5 = { class: "form-section" }
const _hoisted_6 = { class: "form-section-title" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6 mb-3" }
const _hoisted_9 = {
  for: "name",
  class: "form-label required"
}
const _hoisted_10 = ["placeholder", "disabled"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "col-md-6 mb-3" }
const _hoisted_15 = {
  for: "code",
  class: "form-label"
}
const _hoisted_16 = ["placeholder", "disabled"]
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = {
  for: "description",
  class: "form-label"
}
const _hoisted_21 = ["placeholder", "disabled"]
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6 mb-3" }
const _hoisted_24 = {
  for: "hierarchyName",
  class: "form-label"
}
const _hoisted_25 = ["placeholder", "disabled"]
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = { class: "col-md-6 mb-3" }
const _hoisted_28 = { class: "form-label" }
const _hoisted_29 = { class: "form-check form-switch" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  for: "isActive",
  class: "form-check-label"
}
const _hoisted_32 = { class: "form-section" }
const _hoisted_33 = { class: "form-section-title" }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = {
  for: "asset-group-parent",
  class: "form-label"
}
const _hoisted_36 = { class: "text-muted" }
const _hoisted_37 = { class: "form-section" }
const _hoisted_38 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_39 = { class: "form-section-title mb-0" }
const _hoisted_40 = { class: "form-check form-switch" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  for: "asset-group-hasLocation",
  class: "form-check-label"
}
const _hoisted_43 = {
  key: 0,
  class: "location-fields"
}
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-md-12 mb-3" }
const _hoisted_46 = {
  for: "street",
  class: "form-label"
}
const _hoisted_47 = ["placeholder", "disabled"]
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-4 mb-3" }
const _hoisted_50 = {
  for: "city",
  class: "form-label"
}
const _hoisted_51 = ["placeholder", "disabled"]
const _hoisted_52 = { class: "col-md-4 mb-3" }
const _hoisted_53 = {
  for: "postalCode",
  class: "form-label"
}
const _hoisted_54 = ["placeholder", "disabled"]
const _hoisted_55 = { class: "col-md-4 mb-3" }
const _hoisted_56 = {
  for: "country",
  class: "form-label"
}
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { value: null }
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-12 mb-3" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_64 = {
  key: 1,
  class: "bi bi-geo-alt-fill me-2"
}
const _hoisted_65 = {
  key: 1,
  class: "text-muted d-block mt-1"
}
const _hoisted_66 = {
  key: 2,
  class: "alert alert-danger alert-sm mt-2 mb-0"
}
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-md-6 mb-3" }
const _hoisted_69 = {
  for: "lat",
  class: "form-label"
}
const _hoisted_70 = ["placeholder", "disabled"]
const _hoisted_71 = { class: "col-md-6 mb-3" }
const _hoisted_72 = {
  for: "lng",
  class: "form-label"
}
const _hoisted_73 = ["placeholder", "disabled"]
const _hoisted_74 = { class: "form-section" }
const _hoisted_75 = { class: "form-section-title" }
const _hoisted_76 = { class: "mb-3" }
const _hoisted_77 = {
  for: "assetSearch",
  class: "form-label"
}
const _hoisted_78 = {
  key: 0,
  class: "text-info d-block mb-2"
}
const _hoisted_79 = {
  key: 1,
  class: "text-info d-block mb-2"
}
const _hoisted_80 = {
  key: 2,
  class: "asset-select-wrapper position-relative"
}
const _hoisted_81 = { class: "input-group" }
const _hoisted_82 = ["placeholder"]
const _hoisted_83 = {
  key: 0,
  class: "asset-dropdown-results"
}
const _hoisted_84 = {
  key: 0,
  class: "dropdown-item text-muted"
}
const _hoisted_85 = {
  key: 1,
  class: "dropdown-item text-muted"
}
const _hoisted_86 = ["onMousedown"]
const _hoisted_87 = { class: "asset-name" }
const _hoisted_88 = {
  key: 0,
  class: "text-muted ms-2"
}
const _hoisted_89 = {
  key: 3,
  class: "selected-assets-list mt-3"
}
const _hoisted_90 = { class: "form-label text-muted small mb-2" }
const _hoisted_91 = { class: "selected-assets-grid" }
const _hoisted_92 = {
  key: 0,
  class: "text-muted ms-1"
}
const _hoisted_93 = ["onClick"]
const _hoisted_94 = {
  key: 4,
  class: "text-muted small"
}
const _hoisted_95 = { class: "form-section" }
const _hoisted_96 = { class: "form-section-title" }
const _hoisted_97 = { class: "mb-3" }
const _hoisted_98 = {
  for: "vehicleSearch",
  class: "form-label"
}
const _hoisted_99 = {
  key: 0,
  class: "asset-select-wrapper position-relative"
}
const _hoisted_100 = { class: "input-group" }
const _hoisted_101 = ["placeholder"]
const _hoisted_102 = {
  key: 0,
  class: "asset-dropdown-results"
}
const _hoisted_103 = {
  key: 0,
  class: "dropdown-item text-muted"
}
const _hoisted_104 = {
  key: 1,
  class: "dropdown-item text-muted"
}
const _hoisted_105 = ["onMousedown"]
const _hoisted_106 = { class: "asset-name" }
const _hoisted_107 = {
  key: 0,
  class: "text-muted ms-2"
}
const _hoisted_108 = {
  key: 1,
  class: "selected-assets-list mt-3"
}
const _hoisted_109 = { class: "form-label text-muted small mb-2" }
const _hoisted_110 = { class: "selected-assets-grid" }
const _hoisted_111 = {
  key: 0,
  class: "text-muted ms-1"
}
const _hoisted_112 = ["onClick"]
const _hoisted_113 = {
  key: 2,
  class: "text-muted small"
}
const _hoisted_114 = { class: "form-section" }
const _hoisted_115 = { class: "form-section-title" }
const _hoisted_116 = { class: "mb-3" }
const _hoisted_117 = {
  for: "userSearch",
  class: "form-label"
}
const _hoisted_118 = ["placeholder", "disabled"]
const _hoisted_119 = {
  key: 0,
  class: "user-search-results mt-2"
}
const _hoisted_120 = ["onClick"]
const _hoisted_121 = { class: "text-muted ms-2" }
const _hoisted_122 = {
  key: 1,
  class: "selected-users mt-3"
}
const _hoisted_123 = ["onClick"]
const _hoisted_124 = { class: "form-section" }
const _hoisted_125 = { class: "form-section-title" }
const _hoisted_126 = { class: "mb-3" }
const _hoisted_127 = { class: "form-check" }
const _hoisted_128 = ["disabled"]
const _hoisted_129 = {
  for: "update-notifications-enabled",
  class: "form-check-label fw-bold"
}
const _hoisted_130 = { class: "text-muted d-block mt-1" }
const _hoisted_131 = { class: "mb-3" }
const _hoisted_132 = { class: "form-label" }
const _hoisted_133 = { class: "form-check" }
const _hoisted_134 = ["disabled"]
const _hoisted_135 = {
  for: "notif-channel-email",
  class: "form-check-label"
}
const _hoisted_136 = { class: "form-check mt-2" }
const _hoisted_137 = ["disabled"]
const _hoisted_138 = {
  for: "notif-channel-sms",
  class: "form-check-label"
}
const _hoisted_139 = { class: "form-check mt-2" }
const _hoisted_140 = ["disabled"]
const _hoisted_141 = {
  for: "notif-channel-mercure",
  class: "form-check-label"
}
const _hoisted_142 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_143 = { class: "form-check form-switch" }
const _hoisted_144 = ["disabled"]
const _hoisted_145 = {
  for: "include-descendants",
  class: "form-check-label"
}
const _hoisted_146 = { class: "text-muted d-block mt-1" }
const _hoisted_147 = ["disabled"]
const _hoisted_148 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HierarchicalSelect = _resolveComponent("HierarchicalSelect")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "modalRef",
    nested: false,
    size: "lg"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, [
        (_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('components.assetGroups.modal.viewTitle')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.isEditMode ? _ctx.$t('components.assetGroups.modal.editTitle') : _ctx.$t('components.assetGroups.modal.createTitle')), 1))
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[37] || (_cache[37] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _cache[33] || (_cache[33] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, [
              _cache[38] || (_cache[38] = _createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.basicInfo')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.name')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.name.$model) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.name.$error }]),
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.name'),
                  disabled: _ctx.isReadOnly
                }, null, 10, _hoisted_10), [
                  [_vModelText, _ctx.v$.form.name.$model]
                ]),
                (_ctx.v$.form.name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_ctx.v$.form.name.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('components.assetGroups.modal.validation.nameRequired')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.v$.form.name.minLength.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('components.assetGroups.modal.validation.nameMinLength', { min: 3 })), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.code')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "code",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.code.$model) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.code.$error }]),
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.code'),
                  disabled: _ctx.isReadOnly
                }, null, 10, _hoisted_16), [
                  [_vModelText, _ctx.v$.form.code.$model]
                ]),
                (_ctx.v$.form.code.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_ctx.v$.form.code.maxLength.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('components.assetGroups.modal.validation.codeMaxLength', { max: 50 })), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.description')), 1),
              _withDirectives(_createElementVNode("textarea", {
                id: "description",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event)),
                class: "form-control",
                rows: "3",
                placeholder: _ctx.$t('components.assetGroups.modal.placeholders.description'),
                disabled: _ctx.isReadOnly
              }, null, 8, _hoisted_21), [
                [_vModelText, _ctx.form.description]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.hierarchyName')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "hierarchyName",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.hierarchyName) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.hierarchyName'),
                  disabled: _ctx.isReadOnly
                }, null, 8, _hoisted_25), [
                  [_vModelText, _ctx.form.hierarchyName]
                ]),
                _createElementVNode("small", _hoisted_26, _toDisplayString(_ctx.$t('components.assetGroups.modal.hints.hierarchyName')), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.status')), 1),
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    id: "isActive",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.isActive) = $event)),
                    type: "checkbox",
                    class: "form-check-input",
                    role: "switch",
                    disabled: _ctx.isReadOnly
                  }, null, 8, _hoisted_30), [
                    [_vModelCheckbox, _ctx.form.isActive]
                  ]),
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.form.isActive ? _ctx.$t('components.assetGroups.modal.active') : _ctx.$t('components.assetGroups.modal.inactive')), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("h5", _hoisted_33, [
              _cache[39] || (_cache[39] = _createElementVNode("i", { class: "bi bi-diagram-2 me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.hierarchy')), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.parent')), 1),
              _createVNode(_component_HierarchicalSelect, {
                modelValue: _ctx.form.parentId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.parentId) = $event)),
                id: "asset-group-parent",
                nodes: _ctx.parentTreeOptions,
                placeholder: _ctx.$t('components.assetGroups.modal.noParent'),
                "search-placeholder": _ctx.$t('components.assetGroups.modal.searchParent'),
                "clear-label": _ctx.$t('components.assetGroups.modal.clearParent'),
                "no-results-label": _ctx.$t('components.assetGroups.modal.noResults'),
                "no-nodes-label": _ctx.$t('components.assetGroups.modal.noGroups'),
                searchable: true,
                "allow-null": true,
                disabled: !_ctx.canChangeParent || _ctx.isReadOnly
              }, null, 8, ["modelValue", "nodes", "placeholder", "search-placeholder", "clear-label", "no-results-label", "no-nodes-label", "disabled"]),
              _createElementVNode("small", _hoisted_36, _toDisplayString(_ctx.$t('components.assetGroups.modal.hints.parent')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h5", _hoisted_39, [
                _cache[40] || (_cache[40] = _createElementVNode("i", { class: "bi bi-geo-alt me-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.location')), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  id: "asset-group-hasLocation",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.hasLocation) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  role: "switch",
                  disabled: _ctx.isReadOnly
                }, null, 8, _hoisted_41), [
                  [_vModelCheckbox, _ctx.hasLocation]
                ]),
                _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('components.assetGroups.modal.hasLocation')), 1)
              ])
            ]),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (_ctx.hasLocation)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.street')), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "street",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.location.street) = $event)),
                            type: "text",
                            class: "form-control",
                            placeholder: _ctx.$t('components.assetGroups.modal.placeholders.street'),
                            disabled: _ctx.isReadOnly
                          }, null, 8, _hoisted_47), [
                            [_vModelText, _ctx.form.location.street]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.city')), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "city",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.location.city) = $event)),
                            type: "text",
                            class: "form-control",
                            placeholder: _ctx.$t('components.assetGroups.modal.placeholders.city'),
                            disabled: _ctx.isReadOnly
                          }, null, 8, _hoisted_51), [
                            [_vModelText, _ctx.form.location.city]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.postalCode')), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "postalCode",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.location.postalCode) = $event)),
                            type: "text",
                            class: "form-control",
                            placeholder: _ctx.$t('components.assetGroups.modal.placeholders.postalCode'),
                            disabled: _ctx.isReadOnly
                          }, null, 8, _hoisted_54), [
                            [_vModelText, _ctx.form.location.postalCode]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.country')), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "country",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.location.country) = $event)),
                            class: "form-select",
                            disabled: _ctx.isReadOnly
                          }, [
                            _createElementVNode("option", _hoisted_58, _toDisplayString(_ctx.$t('components.assetGroups.modal.selectCountry')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (countryName, countryKey) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: countryKey,
                                value: countryKey
                              }, _toDisplayString(countryName), 9, _hoisted_59))
                            }), 128))
                          ], 8, _hoisted_57), [
                            [_vModelSelect, _ctx.form.location.country]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          (!_ctx.isReadOnly)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-outline-primary btn-sm",
                                disabled: _ctx.loadingGeocode || !_ctx.form.location.street || !_ctx.form.location.city,
                                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleGeocode && _ctx.handleGeocode(...args)))
                              }, [
                                (_ctx.loadingGeocode)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_63))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_64)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.geocodeButton')), 1)
                              ], 8, _hoisted_62))
                            : _createCommentVNode("", true),
                          (!_ctx.geocodeError)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_65, _toDisplayString(_ctx.$t('components.assetGroups.modal.hints.geocode')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.geocodeError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                _cache[41] || (_cache[41] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(_ctx.geocodeError), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.latitude')), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "lat",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.location.lat) = $event)),
                            type: "number",
                            step: "0.000001",
                            class: "form-control",
                            placeholder: _ctx.$t('components.assetGroups.modal.placeholders.latitude'),
                            min: "-90",
                            max: "90",
                            disabled: _ctx.isReadOnly
                          }, null, 8, _hoisted_70), [
                            [
                              _vModelText,
                              _ctx.form.location.lat,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.longitude')), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "lng",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.location.lng) = $event)),
                            type: "number",
                            step: "0.000001",
                            class: "form-control",
                            placeholder: _ctx.$t('components.assetGroups.modal.placeholders.longitude'),
                            min: "-180",
                            max: "180",
                            disabled: _ctx.isReadOnly
                          }, null, 8, _hoisted_73), [
                            [
                              _vModelText,
                              _ctx.form.location.lng,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("h5", _hoisted_75, [
              _cache[42] || (_cache[42] = _createElementVNode("i", { class: "bi bi-box-seam me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.assets')), 1)
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.assignAssets')), 1),
              (_ctx.isEditMode && _ctx.form.parentId)
                ? (_openBlock(), _createElementBlock("small", _hoisted_78, [
                    _cache[43] || (_cache[43] = _createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.hints.assetsFromParent')), 1)
                  ]))
                : (!_ctx.isEditMode && _ctx.form.parentId)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_79, [
                      _cache[44] || (_cache[44] = _createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.hints.assetsFromParentNew')), 1)
                    ]))
                  : _createCommentVNode("", true),
              (!_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _cache[46] || (_cache[46] = _createElementVNode("span", { class: "input-group-text" }, [
                        _createElementVNode("i", { class: "bi bi-box-seam" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "assetSearch",
                        ref: "assetSearchInputRef",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.assetSearch) = $event)),
                        type: "text",
                        class: "form-control",
                        placeholder: _ctx.$t('components.assetGroups.modal.placeholders.selectAsset'),
                        autocomplete: "off",
                        onFocus: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onAssetInputFocus && _ctx.onAssetInputFocus(...args))),
                        onInput: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.searchAssets && _ctx.searchAssets(...args))),
                        onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onAssetInputBlur && _ctx.onAssetInputBlur(...args)))
                      }, null, 40, _hoisted_82), [
                        [_vModelText, _ctx.assetSearch]
                      ]),
                      (_ctx.assetSearch)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-outline-secondary",
                            onMousedown: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearAssetSearch && _ctx.clearAssetSearch(...args)), ["prevent"]))
                          }, [...(_cache[45] || (_cache[45] = [
                            _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                          ]))], 32))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary",
                        onMousedown: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAssetDropdown && _ctx.toggleAssetDropdown(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["bi", _ctx.showAssetDropdown ? 'bi-chevron-up' : 'bi-chevron-down'])
                        }, null, 2)
                      ], 32)
                    ]),
                    (_ctx.showAssetDropdown && !_ctx.isReadOnly)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                          (_ctx.assetSearchLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                _cache[47] || (_cache[47] = _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.loadingAssets')), 1)
                              ]))
                            : (_ctx.availableAssets.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                  _cache[48] || (_cache[48] = _createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.noAvailableAssets')), 1)
                                ]))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.availableAssets, (asset) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: asset.id,
                                    class: "dropdown-item asset-dropdown-item",
                                    onMousedown: _withModifiers(($event: any) => (_ctx.addAsset(asset)), ["prevent"])
                                  }, [
                                    _cache[49] || (_cache[49] = _createElementVNode("i", { class: "bi bi-plus-circle me-2 text-success" }, null, -1)),
                                    _createElementVNode("span", _hoisted_87, _toDisplayString(asset.name || asset.serialNumber), 1),
                                    (asset.serialNumber && asset.name)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_88, "(" + _toDisplayString(asset.serialNumber) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ], 40, _hoisted_86))
                                }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedAssets.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.$t('components.assetGroups.modal.selectedAssets')) + " (" + _toDisplayString(_ctx.selectedAssets.length) + ") ", 1),
                    _createElementVNode("div", _hoisted_91, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAssets, (asset) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: asset.id,
                          class: "selected-asset-badge"
                        }, [
                          _cache[51] || (_cache[51] = _createElementVNode("i", { class: "bi bi-box-seam me-1" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(asset.name || asset.serialNumber), 1),
                          (asset.serialNumber && asset.name)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_92, "(" + _toDisplayString(asset.serialNumber) + ")", 1))
                            : _createCommentVNode("", true),
                          (!_ctx.isReadOnly)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "btn-remove",
                                onClick: ($event: any) => (_ctx.removeAsset(asset.id))
                              }, [...(_cache[50] || (_cache[50] = [
                                _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                              ]))], 8, _hoisted_93))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(_ctx.$t('components.assetGroups.modal.noAssetsAssigned')), 1))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("h5", _hoisted_96, [
              _cache[52] || (_cache[52] = _createElementVNode("i", { class: "bi bi-truck me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.vehicles')), 1)
            ]),
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.assignVehicles')), 1),
              (!_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                    _createElementVNode("div", _hoisted_100, [
                      _cache[54] || (_cache[54] = _createElementVNode("span", { class: "input-group-text" }, [
                        _createElementVNode("i", { class: "bi bi-truck" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "vehicleSearch",
                        ref: "vehicleSearchInputRef",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.vehicleSearch) = $event)),
                        type: "text",
                        class: "form-control",
                        placeholder: _ctx.$t('components.assetGroups.modal.placeholders.selectVehicle'),
                        autocomplete: "off",
                        onFocus: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onVehicleInputFocus && _ctx.onVehicleInputFocus(...args))),
                        onInput: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.searchVehicles && _ctx.searchVehicles(...args))),
                        onBlur: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onVehicleInputBlur && _ctx.onVehicleInputBlur(...args)))
                      }, null, 40, _hoisted_101), [
                        [_vModelText, _ctx.vehicleSearch]
                      ]),
                      (_ctx.vehicleSearch)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-outline-secondary",
                            onMousedown: _cache[24] || (_cache[24] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearVehicleSearch && _ctx.clearVehicleSearch(...args)), ["prevent"]))
                          }, [...(_cache[53] || (_cache[53] = [
                            _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                          ]))], 32))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary",
                        onMousedown: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleVehicleDropdown && _ctx.toggleVehicleDropdown(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["bi", _ctx.showVehicleDropdown ? 'bi-chevron-up' : 'bi-chevron-down'])
                        }, null, 2)
                      ], 32)
                    ]),
                    (_ctx.showVehicleDropdown && !_ctx.isReadOnly)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                          (_ctx.vehicleSearchLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                _cache[55] || (_cache[55] = _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.loadingVehicles')), 1)
                              ]))
                            : (_ctx.availableVehicles.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                  _cache[56] || (_cache[56] = _createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.noAvailableVehicles')), 1)
                                ]))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.availableVehicles, (vehicle) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: vehicle.id,
                                    class: "dropdown-item asset-dropdown-item",
                                    onMousedown: _withModifiers(($event: any) => (_ctx.addVehicle(vehicle)), ["prevent"])
                                  }, [
                                    _cache[57] || (_cache[57] = _createElementVNode("i", { class: "bi bi-plus-circle me-2 text-success" }, null, -1)),
                                    _createElementVNode("span", _hoisted_106, _toDisplayString(vehicle.registration), 1),
                                    (vehicle.imei)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_107, "(" + _toDisplayString(vehicle.imei) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ], 40, _hoisted_105))
                                }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedVehicles.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                    _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t('components.assetGroups.modal.selectedVehicles')) + " (" + _toDisplayString(_ctx.selectedVehicles.length) + ") ", 1),
                    _createElementVNode("div", _hoisted_110, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedVehicles, (vehicle) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: vehicle.id,
                          class: "selected-asset-badge"
                        }, [
                          _cache[59] || (_cache[59] = _createElementVNode("i", { class: "bi bi-truck me-1" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(vehicle.registration), 1),
                          (vehicle.imei)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_111, "(" + _toDisplayString(vehicle.imei) + ")", 1))
                            : _createCommentVNode("", true),
                          (!_ctx.isReadOnly)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "btn-remove",
                                onClick: ($event: any) => (_ctx.removeVehicle(vehicle.id))
                              }, [...(_cache[58] || (_cache[58] = [
                                _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                              ]))], 8, _hoisted_112))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(_ctx.$t('components.assetGroups.modal.noVehiclesAssigned')), 1))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_114, [
            _createElementVNode("h5", _hoisted_115, [
              _cache[60] || (_cache[60] = _createElementVNode("i", { class: "bi bi-people me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.users')), 1)
            ]),
            _createElementVNode("div", _hoisted_116, [
              _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.assignUsers')), 1),
              _withDirectives(_createElementVNode("input", {
                id: "userSearch",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.userSearch) = $event)),
                type: "text",
                class: "form-control",
                placeholder: _ctx.$t('components.assetGroups.modal.placeholders.searchUsers'),
                disabled: _ctx.isReadOnly,
                onInput: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.searchUsers && _ctx.searchUsers(...args)))
              }, null, 40, _hoisted_118), [
                [_vModelText, _ctx.userSearch]
              ]),
              (!_ctx.isReadOnly && _ctx.userSearchResults.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userSearchResults, (user) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: user.id,
                        class: "user-search-item",
                        onClick: ($event: any) => (_ctx.addUser(user))
                      }, [
                        _cache[61] || (_cache[61] = _createElementVNode("i", { class: "bi bi-person-plus me-2" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(user.email), 1),
                        _createElementVNode("small", _hoisted_121, _toDisplayString(user.name) + " " + _toDisplayString(user.surname), 1)
                      ], 8, _hoisted_120))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedUsers.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (user) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: user.id,
                        class: "selected-user-badge"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(user.email), 1),
                        (!_ctx.isReadOnly)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn-remove",
                              onClick: ($event: any) => (_ctx.removeUser(user.id))
                            }, [...(_cache[62] || (_cache[62] = [
                              _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                            ]))], 8, _hoisted_123))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_124, [
            _createElementVNode("h5", _hoisted_125, [
              _cache[63] || (_cache[63] = _createElementVNode("i", { class: "bi bi-bell me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.notificationSettings')), 1)
            ]),
            _createElementVNode("div", _hoisted_126, [
              _createElementVNode("div", _hoisted_127, [
                _withDirectives(_createElementVNode("input", {
                  id: "update-notifications-enabled",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.notificationSettings.updateEnabled) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: _ctx.isReadOnly
                }, null, 8, _hoisted_128), [
                  [_vModelCheckbox, _ctx.notificationSettings.updateEnabled]
                ]),
                _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.isEditMode ? _ctx.$t('components.assetGroups.modal.updateNotificationChannels') : _ctx.$t('components.assetGroups.modal.setNotificationChannels')), 1)
              ]),
              _createElementVNode("small", _hoisted_130, _toDisplayString(_ctx.isEditMode ? _ctx.$t('components.assetGroups.modal.hints.updateNotificationChannels') : _ctx.$t('components.assetGroups.modal.hints.setNotificationChannels')), 1)
            ]),
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.notificationChannels')), 1),
              _createElementVNode("div", _hoisted_133, [
                _withDirectives(_createElementVNode("input", {
                  id: "notif-channel-email",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.notificationSettings.channels.email) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: _ctx.isReadOnly || !_ctx.notificationSettings.updateEnabled
                }, null, 8, _hoisted_134), [
                  [_vModelCheckbox, _ctx.notificationSettings.channels.email]
                ]),
                _createElementVNode("label", _hoisted_135, [
                  _cache[64] || (_cache[64] = _createElementVNode("i", { class: "bi bi-envelope me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.channels.email')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_136, [
                _withDirectives(_createElementVNode("input", {
                  id: "notif-channel-sms",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.notificationSettings.channels.sms) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: _ctx.isReadOnly || !_ctx.notificationSettings.updateEnabled
                }, null, 8, _hoisted_137), [
                  [_vModelCheckbox, _ctx.notificationSettings.channels.sms]
                ]),
                _createElementVNode("label", _hoisted_138, [
                  _cache[65] || (_cache[65] = _createElementVNode("i", { class: "bi bi-phone me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.channels.sms')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_139, [
                _withDirectives(_createElementVNode("input", {
                  id: "notif-channel-mercure",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.notificationSettings.channels.mercure) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: _ctx.isReadOnly || !_ctx.notificationSettings.updateEnabled
                }, null, 8, _hoisted_140), [
                  [_vModelCheckbox, _ctx.notificationSettings.channels.mercure]
                ]),
                _createElementVNode("label", _hoisted_141, [
                  _cache[66] || (_cache[66] = _createElementVNode("i", { class: "bi bi-broadcast me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.channels.mercure')), 1)
                ])
              ])
            ]),
            (_ctx.isEditMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, [
                    _withDirectives(_createElementVNode("input", {
                      id: "include-descendants",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.notificationSettings.includeDescendants) = $event)),
                      type: "checkbox",
                      class: "form-check-input",
                      role: "switch",
                      disabled: _ctx.isReadOnly || !_ctx.notificationSettings.updateEnabled
                    }, null, 8, _hoisted_144), [
                      [_vModelCheckbox, _ctx.notificationSettings.includeDescendants]
                    ]),
                    _createElementVNode("label", _hoisted_145, _toDisplayString(_ctx.$t('components.assetGroups.modal.includeDescendants')), 1)
                  ]),
                  _createElementVNode("small", _hoisted_146, _toDisplayString(_ctx.$t('components.assetGroups.modal.hints.notificationSettings')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ])
    ]),
    footer: _withCtx(() => [
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _toDisplayString(_ctx.$t('components.assetGroups.modal.cancel')), 1))
        : _createCommentVNode("", true),
      (_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _toDisplayString(_ctx.$t('components.assetGroups.modal.close')), 1))
        : _createCommentVNode("", true),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "btn btn-primary",
            disabled: _ctx.loading || _ctx.v$.$invalid,
            onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_148))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.isEditMode ? _ctx.$t('components.assetGroups.modal.update') : _ctx.$t('components.assetGroups.modal.create')), 1)
          ], 8, _hoisted_147))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}